import {ANALYTICS_BASE, SETTINGS_BASE, SETTINGS_LOGIN_INTEGRATION} from "@irati-web/admin/src/routes/routeConfig"

export default function shouldSecondNavigationRender() {
  const acceptedRoutes = [SETTINGS_BASE, ANALYTICS_BASE]
  const excludedRoutes = [SETTINGS_LOGIN_INTEGRATION]

  const appPath = "admin"
  const pathname = window.location.pathname

  const isRouteAccepted = acceptedRoutes.find((route) => {
    return pathname === `${appPath}${route}` || pathname.includes(`${appPath}${route}`)
  })
  const isRouteExcluded = excludedRoutes.find((route) => pathname === `${appPath}${route}` || pathname.includes(`${appPath}${route}`))

  if (isRouteAccepted) {
    return !isRouteExcluded
  }
  return false
}
